/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

import { config } from 'config/env-config';
import { myPostBaseUrl } from 'config/track-config';
import { CustomerState } from 'models/Customer';
import { HeaderConfig } from 'models/Window';
import { authService } from 'store/customer/utils/auth0.util';
import { useAppSelector } from 'store/store';
import { loginAndReturn } from 'utils/login.utils';

import { useScript } from '../../hooks/useScript';
import { AP_HEADER_TEST_ID } from './Header.test-ids';

interface HeaderWindow extends Window {
  __AUSPOST__: {
    header: {
      loadAuthenticationMode: (isAuthenticated: boolean, config: any, authWebService: any) => void;
    };
  };
}
declare const window: HeaderWindow;

const updateHeader = (customer: CustomerState) => {
  const headerConfig: HeaderConfig = {
    env: { envUrl: config.env.url },
    appName: 'track',
    logout: {
      logoutType: 'OIDC',
      url: config.env.url,
    },
    loginHandler: async function (): Promise<void> {
      await authService?.logout(myPostBaseUrl + '/track/', true);
      const redirectUrl = window.location.href;
      await loginAndReturn(redirectUrl);
    },
  };
  const isAuthed = customer.data?.isAuthenticated;
  const header = window.__AUSPOST__?.header;
  if (!header) return;

  const firstName = customer?.data?.info?.firstName;
  if (!isAuthed || !firstName) {
    // if not auth or no firstname, load anon header
    header.loadAuthenticationMode(false, headerConfig, authService);
  } else {
    // else set firstname and load auth header
    headerConfig.customer = { firstName };
    header.loadAuthenticationMode(true, headerConfig, authService);
  }
};

const Header: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ ...props }) => {
  const customerState = useAppSelector((state) => state.customer);
  const [isHeaderScriptLoaded, setIsHeaderScriptLoaded] = React.useState(Boolean(window.__AUSPOST__?.header));

  useScript(`${config.env.url}/website-header/header-v2.js`, () => setIsHeaderScriptLoaded(true));

  React.useEffect(() => {
    if (!isHeaderScriptLoaded) return;
    updateHeader(customerState);
  }, [customerState, isHeaderScriptLoaded]);

  return <div id='auspost-header' data-testid={AP_HEADER_TEST_ID} {...props} onClick={toggleSidebarNav}></div>;
};

export default Header;

const toggleSidebarNav = () => {
  const branchBannerIframe = document.getElementById('branch-banner-iframe');
  const sidebarNavContainer = document.getElementById('sidebar-nav-container');
  if (!branchBannerIframe || !sidebarNavContainer) return;
  if (sidebarNavContainer.classList.contains('is-active')) {
    branchBannerIframe.style.position = 'fixed';
    branchBannerIframe.style.zIndex = '-1';
  } else {
    branchBannerIframe.style.zIndex = '99999';
  }
};
